import { useState, useEffect, useCallback } from "react";
import style from "./inputPassword.module.css";
import Placeholder from "../placeholder/Placeholder"; // Certifique-se de que o Placeholder esteja sendo importado corretamente

const InputPassword = ({
  value,
  onChange,
  msgErro = "",
  required = true,
  className = null,
  onFocus = null,
  onBlur = null,
  label = "Senha",
  name = "senha"
}) => {
  const [error, setError] = useState(false);

  const shake = useCallback(() => {
    if (error) {
      // Se houver erro, aplica o efeito de shake
      setTimeout(() => {
        setError(false);
      }, 300);
    }
  }, [error]);

  useEffect(() => {
    if (msgErro) {
      setError(true);
      shake();
    }
  }, [msgErro, shake]);

  return (
    <>
      <div className={style.passwordField}>
        <Placeholder
          label={label} // O label "Senha" vai ser usado pelo Placeholder
          type="password"
          name={name}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          required={required}
          className={className ? className : style.inputPassword}
          error={!!msgErro}
        />
      </div>
      {error && <div className={style.error}>{msgErro}</div>}
    </>
  );
};

export default InputPassword;
